<script lang="ts">
	import { onDestroy, onMount } from "svelte"
	import DeviceFilter from "../../reusable/device-filter/DeviceFilter.svelte"
	import ScheduleCalendar from "./ScheduleCalendar.svelte"
	import { ScheduleController } from "./ScheduleController"
	import ScheduleInputs from "./schedule-inputs/ScheduleInputs.svelte"
	import {
		DataHandlerDevice,
		DataHandlerLightshow,
		DataHandlerScene,
		type Device,
	} from "luxedo-data"
	import { Responsive } from "responsive"

	let isEditingEvent: boolean = $state(false)
	let filterDevice: Device = $state(undefined)
	let isMobile = $derived(Responsive.isMobile)

	let hideLeft = $derived(isMobile && isEditingEvent)

	const unsubscribe = ScheduleController.subscribe((ctx) => {
		isEditingEvent = ctx.isScheduling

		if (ctx.filterDevice !== filterDevice) {
			filterDevice = ctx.filterDevice
			setTimeout(() => ScheduleController.Calendar.refreshEvents({ deviceFilter: filterDevice }))
		}
	})

	function scheduleEvent() {
		ScheduleController.EventEditor.editEvent(undefined, { device: filterDevice })
	}

	function loadUrlParams() {
		const clearEncode = (str: string) => {
			return Number(str.replace(/\$/g, ""))
		}

		const urlParams = new URLSearchParams(window.location.search)

		let device
		let project
		if (urlParams.get("device") && urlParams.get("project")) {
			const deviceId = clearEncode(urlParams.get("device"))
			const projectId = clearEncode(urlParams.get("project"))

			device = DataHandlerDevice.get(deviceId)
			project = DataHandlerScene.get(projectId) ?? DataHandlerLightshow.get(projectId)
		}

		if (device || project)
			ScheduleController.EventEditor.editEvent(undefined, {
				show: project,
				device: device,
			})
	}

	onMount(() => {
		ScheduleController.selectDeviceFilter(undefined)
		loadUrlParams()
	})

	onDestroy(unsubscribe)
</script>

<div class="schedule-container" class:isMobile>
	<div class="schedule-left" class:hideLeft>
		<div class="schedule-heading">
			<h1>My Schedule</h1>
			{#if !isEditingEvent}
				<button class="outline-button new-event-button" onclick={scheduleEvent}
					>Schedule New Event</button
				>
			{/if}
		</div>
		<ScheduleCalendar />
	</div>

	{#if isMobile}
		{#if isEditingEvent}
			<div class="mobile-scheduler">
				<ScheduleInputs />
			</div>
		{/if}
	{:else}
		<div class="schedule-right">
			{#if isEditingEvent}
				<ScheduleInputs />
			{:else if DataHandlerDevice.getMany().length}
				<DeviceFilter
					selectedDevice={filterDevice}
					onSetDeviceFilter={ScheduleController.selectDeviceFilter}
				/>
			{/if}
		</div>
	{/if}
</div>

<style>
	.schedule-container {
		display: flex;
		flex-direction: row;
		height: 100%;
		width: 100%;
	}

	.schedule-heading {
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.schedule-left {
		margin-right: 1rem;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}

	.schedule-left.hideLeft {
		display: none;
	}

	.isMobile .schedule-left {
		margin: 1rem 1rem 0 1rem;
	}

	.schedule-right {
		height: calc(100% - 1rem);
		display: flex;
		flex-direction: column;
		transition: width 500ms;
	}

	.schedule-right:empty {
		display: none;
	}

	.schedule-right:global(:has(#schedule-inputs)) {
		width: 40%;
	}

	h1 {
		font-size: var(--h1);
		margin: 0;
		color: var(--color-text-light);
	}

	.mobile-scheduler {
		width: 100%;
	}

	.schedule-container.isMobile .new-event-button {
		padding: 0 1rem;
	}
</style>
